import { OpenTo } from "@/generated-api";
import heart from "@/assets/emoji_hearts.png";
import palm from "@/assets/palm_tree.png";
import champagne from "@/assets/clinking_glasses.png";

export const OPEN_TO_EMOJI_MAP: Record<OpenTo, React.ReactNode> = {
  [OpenTo.DATES]: <img src={champagne} className="w-5 h-5" />,
  [OpenTo.RELATIONSHIP]: <img src={heart} className="w-5 h-5" />,
  [OpenTo.TRAVEL_TOGETHER]: <img src={palm} className="w-5 h-5" />,
};
